module.exports = __webpack_public_path__ + "img/google_json.74a6cfb6.jpg";